<template>
    <div class="row align-items-center justify-content-center" style="min-height: 100vh">
        <div class="col-12 col-md-8 col-xl-6">             
            <Card>
                <h5 class="font-weight-bold mb-heading">{{ __('Registration was successful. You will receive confirmation email after administrator confirms your account.') }}</h5>
            </Card>
            <div class="card-after">
                <router-link
                    class="btn btn-secondary btn-sm w-25"
                    to="/login"
                >
                    {{ __('Back') }}
                </router-link>               
            </div>
        </div>
    </div>
</template>

<script>


export default {
  name: 'RegisterSuccess',
  data () {
    return {
     
    }
  },

  methods: {
  
  }
}
</script>
